import Api from '@/services/Api'

export default {
    getSubMenuByRolByMenu(idRol,idMenu){
        return Api().get('rolemenu/getSubMenuByRolByMenu/'+idRol+'/'+idMenu)
    },
    updateAsociacionRolemenu(datosForm){
        return Api().put('rolemenu/updateAsociacionRolemenu',datosForm)
    },
}